import _startCase from 'lodash/startCase';
import _toLower from 'lodash/toLower';
import _upperFirst from 'lodash/upperFirst';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { DataImport, DataImportStatusEnum } from 'graphql-common';
import Chip from '@lib/components/Chip/Chip';
import { getDataImportStatusChipType } from '@lib/utils/dataImport';
import CircleLoader from '@lib/components/CircleLoader/CircleLoader';

type Props = {
  data: DataImport;
};

export default function DataImportStatusChip(props: Props) {
  const { data } = props;
  const { status } = data;
  const { t } = useTranslation();
  const options = [
    { value: DataImportStatusEnum.Complete, title: t('completed') },
    { value: DataImportStatusEnum.Failed, title: t('failed') },
    { value: DataImportStatusEnum.Interrupted, title: t('interrupted') },
    { value: DataImportStatusEnum.Queued, title: t('queued') },
    { value: DataImportStatusEnum.Retrying, title: t('retrying') },
    { value: DataImportStatusEnum.Stopped, title: t('stopped') },
    { value: DataImportStatusEnum.Working, title: t('import-pending') },
  ];
  let label: string | undefined = '-';
  if (status) {
    label = options.find(({ value }) => value === status)?.title;
  }
  if (label === undefined) label = _upperFirst(_toLower(_startCase(status)));
  const type = getDataImportStatusChipType(status);
  const isWorking = status === DataImportStatusEnum.Working;
  return (
    <Chip
      type={type}
      label={label}
      leftIcon={isWorking ? undefined : 'circle'}
      leftIconComponent={
        isWorking ? <CircleLoader size={16} strokeWidth={2} /> : undefined
      }
    />
  );
}
